/*
 *  (c) 2015 - 2021 ENISCO by FORCAM GmbH
 */

import {useDispatch, useSelector} from 'react-redux'
import {AppRootState} from '../model/config'
import {setSearch} from '../store/appsSlice'

const useSearch = (): [string | undefined, (newSearch: string) => void] => {
  const search = useSelector((state: AppRootState) => state.app.search)
  const dispatch = useDispatch()
  const setter = (newSearch: string) => {
    dispatch(setSearch(newSearch))
  }

  return [search, setter]
}

export default useSearch
